export type ConsoleErrorI18nReactProps = {
  error: string;
  heading: string;
};

export const consoleErrorI18nReact = ({
  error,
  heading,
}: ConsoleErrorI18nReactProps) =>
  console.error(`[@i18n/react] ${heading}:\n\t${error}`);
